<template>
    <v-form v-model="isFormValid" ref="replacementForm" lazy-validation>
        <v-card>
        <v-card-title>
            Single Building Primary Contact Replacement
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="2">
                    <v-select :items="buildings" v-model="replacement.buildingCode" 
                            :rules="[v=>!!v || 'Building is requires']" required 
                            @change="onBuildingChange">

                        <template #label>Building <span class="red--text"> <strong>*</strong></span></template>
                    </v-select>
                </v-col>
                <v-col cols="4">
                    <!--
                        <v-select :items="assignedUsers" v-model="replacement.currentUser"
                            :rules="[v=>!!v || 'Current is requires']" required >
                            <template #label>Assigned User <span class="red--text"> <strong>*</strong></span></template>
                        </v-select>
                    -->
                    <v-combobox  
                        v-model="replacement.currentUsers" 
                        :items="assignedUsers"
                        hide-selected
                        multiple
                        label="Current Users" 
                        :readonly=true>

                    </v-combobox>
                </v-col>
                <v-col cols="4">
                    <v-combobox  
                        v-model="replacement.newUsers" 
                        :items="nonAssignedUsers"
                        
                        multiple
                        @change="onNewUserChange">
                        <template #label>New User(s) <span class="red--text"><strong>*</strong></span></template>
                    </v-combobox>


                    <v-dialog v-model="newUser.isNewUserDialogVisible" persistent>
                            <NewUser :userName="newUser.userName" @saved="onNewUserSaved" @canceled="onNewUserCanceled"></NewUser>
                    </v-dialog>
                </v-col>
                <v-col cols="2">
                    <ConfirmationPanel :isVisible="confirm.isVisible" :message="confirm.message" @confirm:click="onConfirmed"></ConfirmationPanel>
                    <v-btn dark class="mb-2" color="success" @click="onSavingReplacement">
                        <v-icon>mdi-content-save</v-icon>
                        Update User</v-btn>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
    </v-form>
    
</template>
<script>
    import radiationAPI from '@/services/radiationservice';
    import userAPI from '@/services/userservice' ;


    export default
    {
        name:'EmailPrimaryReplacementByBuilding',
        data:function(){
            return {
                buildings:[],
                assignedUsers: [],
                nonAssignedUsers: [],
                isFormValid: false,
                replacement:{
                    buildingCode:null,
                    currentUsers: [],
                    newUsers: []
                },
                confirm:{
                    isVisible: false,
                    message: ''
                },
                newUser:{
                    isNewUserDialogVisible:false,
                    userName:''
                }
            }
        },
        components:{
            NewUser: ()=> import('./NewUser'),
            ConfirmationPanel:()=>import('@/views/commond/ConfirmationPanel')
        },
        methods:{
            async loadBuildings(){
                await radiationAPI.getAllBuildings()
                .then(response=>{
                    response.data.map((item)=>
                        {
                            this.buildings.push({ value: item.code, text: item.code+'-'+ item.description})
                        }
                    );
                })
                .catch(error=>{
                    console.log(error);
                })
            },
            async onBuildingChange(building)
            {
                this.replacement.currentUser=null;
                this.replacement.newUser=null;
                
                await userAPI.getPrimaryContactByBuilding(building)
                .then(response=>{
                
                    this.assignedUsers=response;
                    
                })
                .catch(error=>{
                    console.log(error);
                });
                this.replacement.currentUsers=this.assignedUsers;
                //await userAPI.GetNonAssignedPrimaryContactBuilding(building)
                await userAPI.getUsers()
                .then(response=>{
                    response.data.map((user)=>{
                        this.nonAssignedUsers.push({ value: user.userId, text: user.name});
                    });
                })
                .catch(error=>{
                    console.log(error);
                });

                
            },
            async onNewUserChange(newUser)
            {
                if(typeof(newUser)==='string' && newUser.trim())
                {   
                    var value=newUser;
                    console.log('value', newUser);
                    this.newUser.userName=value;
                    const item=this.nonAssignedUsers.find(user=>user.value===value);
                    if(item){
                        this.replacement.newUser={value:item.value, text: item.text };     
                    } else{ 
                        this.newUser.isNewUserDialogVisible=true;   
                    }
                }   
            },
            async onAddingNewUser(){
                this.newUser.isNewUserDialogVisible=true;
            },
            async onNewUserSaved(isSuccessfull,message,newUser){
                if(isSuccessfull)
                {
                    console.log(message);
                    await this.onBuildingChange(this.replacement.buildingCode);
                    this.replacement.newUser={value: newUser.userId, text: newUser.name};
                }
                this.newUser.isNewUserDialogVisible=false;
            },
            async onNewUserCanceled(value){
                this.newUser.isNewUserDialogVisible=value;
            },
            async onSavingReplacement()
            {
                this.isFormValid=this.$refs.replacementForm.validate();
                
                if(this.replacement.newUsers.length<1)
                {
                    this.$emit('PrimaryReplacementBuilding:click',false,`New users are required.`);
                    return;
                }
                //console.log('duplicated, currentUser, newUsers',this.replacement.newUsers.map(item=>item.value).indexOf(this.replacement.currentUser), this.replacement.currentUser, this.replacement.newUsers);
                
                if(this.isFormValid)
                {
                    this.confirm.isVisible=true;
                    this.confirm.message="Primary Contact Building Confirmation";
                }
                
            },
            async onConfirmed(value)
            {
                if(value)
                {
                    //console.log('this.replacement.newUsers',this.replacement.newUsers);
                    let newUsers=[];
                    this.replacement.newUsers.map((user)=>{
                        newUsers.push(user.value);
                    });
                    let user={buildingCode: this.replacement.buildingCode, currentUser: '', replacementUsers: newUsers};
                    await userAPI.MailingContactReplacementByUserFull(this.replacement.buildingCode, user)
                    .then(response=>{
                    this.$emit('PrimaryReplacementBuilding:click',true,`User in building ${this.replacement.buildingCode} was replaced by ${user.replacementUser} in ${response} devices.`);
                    })
                    .catch(error=>{
                        console.log(error);
                        this.$emit('PrimaryReplacementBuilding:click',false,`User ${user.currentUser} could not be replaced.`);
                    })
                }
                this.confirm.isVisible=false;
            }
        },
        mounted:async function()
        {
            await this.loadBuildings();
        }
    }
</script>